import '../bootstrap.js';
import pubmatic from "../js/init/pubmatic"; // DIVIDE desktop and mobile
import cmp from "../js/init/cmp"; // desktop and mobile
import "../js/init/google-gpt"; // desktop and mobile
import "../js/init/setFcIdToAdmanager"; // desktop and mobile
import analytics from "../js/init/analytics"; // DIVIDE desktop and mobile
import tagManager from "../js/init/tag-manager"; // desktop and mobile
import "../js/init/liveramp"; // desktop and mobile
import "../js/init/comscore-init"; // desktop and mobile (by footabllco)
import "../js/deterrent-cmp"; // desktop and mobile
import teadsCookieless from "../js/init/teads-cookieless-init"; // desktop and mobile
import openweb from "../js/init/openweb"; // desktop and mobile
import  "../js/init/clever-adv"; // desktop and mobile

/*
* global debugger
*/
window._debug = () => window.localStorage.getItem('_cm_debug') || new URL(window.location.href).searchParams.has('_debug');
window._enableDebug = () => window.localStorage.setItem('_cm_debug', '1');
window._disableDebug = () => window.localStorage.removeItem('_cm_debug');

const isMobile = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768;


/*
* init Libraries
*/

// for desktop and mobile
cmp('//clickiocmp.com/t/consent_228844.js');

let analyticsId = isMobile ? 'UA-2107172-2' : 'UA-2107172-1';
analytics(analyticsId)
tagManager() // desktop and mobile
teadsCookieless() // desktop and mobile

let pubmaticUrl = isMobile ? '//ads.pubmatic.com/AdServer/js/pwt/156309/3626' : '//ads.pubmatic.com/AdServer/js/pwt/156309/3625';
pubmatic(pubmaticUrl, '//ads.pubmatic.com/AdServer/js/phoenix.js');


openweb('//launcher-sa.spot.im/spot/sp_Y5ZENG8n');
